export default __webpack_public_path__ + "static/media/kiranalogo.45596e55.png";